import { render, staticRenderFns } from "./iconTemplate.vue?vue&type=template&id=15cdef9a&"
import script from "./iconTemplate.vue?vue&type=script&lang=js&"
export * from "./iconTemplate.vue?vue&type=script&lang=js&"
import style0 from "./iconTemplate.vue?vue&type=style&index=0&id=15cdef9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports